import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProfileState {
  user: any;
  error: string;
  success: boolean;
  isUserLogout: boolean;
}

const initialState: ProfileState = {
  user: null,
  error: '',
  success: false,
  isUserLogout: false,
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    profileSuccess(state: ProfileState, action: PayloadAction<string>) {
      state.user = action.payload;
      state.success = true;
    },
    profileFailed(state: ProfileState, action: PayloadAction<string | any>) {
      state.error = action.payload;
      state.success = false;
    },
    logoutSuccess(state: ProfileState, action: PayloadAction<boolean>) {
      state.user = null;
      state.isUserLogout = action.payload;
    },
  },
});

export const { profileSuccess, profileFailed, logoutSuccess } =
  profileSlice.actions;
export default profileSlice.reducer;
